import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';

/** The directory reuses the dossier list-item wire shape (`GET …/subjects`); only `id`, `title` and `type` are read. */
export type SubjectDirectoryFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly SubjectPayload[];
};

export type SubjectDirectoryFetchedAction = {
	type: 'SUBJECT_DIRECTORY_FETCHED';
	payload: SubjectDirectoryFetchedPayload;
	facilityId: number;
};

export default (
	payload: SubjectDirectoryFetchedPayload,
	facilityId: number,
): SubjectDirectoryFetchedAction => ({
	type: 'SUBJECT_DIRECTORY_FETCHED',
	payload,
	facilityId,
});
